module.exports = __webpack_public_path__ + "static/media/mobileHero.24783614.png";